import React from "react";
import Plot from "react-plotly.js";

const TailMatrixChart = ({ data }) => {
  // Filter out diagonal elements
  const filteredData = data.filter((item) => item.x !== item.y);

  // Extract x, y, size, and opacity
  const x = filteredData.map((item) => item.x);
  const y = filteredData.map((item) => item.y);
  const size = filteredData.map((item) => Math.abs(item.value) * 20); // Scale for marker size
  const opacity = filteredData.map((item) => Math.abs(item.value)); // Use value for opacity

  // Define colors based on value threshold
  const colors = filteredData.map((item) =>
    Math.abs(item.value) > 0.9 && Math.abs(item.value) < 1 ? '#FF1493' : '#1f77b4'
  );

  // Custom hover template for better formatting
  const hoverTemplate = filteredData.map(
    (item) => `${item.x.toUpperCase()}<br>${item.y.toUpperCase()}<br><b>${(item.value * 100).toFixed(2)}%</b><extra></extra>`
  );

  return (
    <Plot
      data={[
        {
          x,
          y,
          mode: "markers",
          marker: {
            size,
            color: colors,
            opacity,
          },
          type: "scattergl",
          hovertemplate: hoverTemplate,
        },
      ]}
      layout={{
        margin: {
          t: 20
        },
        xaxis: {
          title: "",
          automargin: true,
          tickfont: { size: 10 }, // Smaller font size
          tickformat: ".0%",
          ticktext: x.map(val => val.toUpperCase()), // Convert to uppercase
          tickvals: x,
        },
        yaxis: {
          title: "",
          automargin: true,
          tickfont: { size: 10 }, // Smaller font size
          tickformat: ".0%",
          ticktext: y.map(val => val.toUpperCase()), // Convert to uppercase
          tickvals: y,
        },
        responsive: true,
        autosize: true,
        height: 600,
        hovermode: "closest",
        showlegend: false,
      }}
      config={{ responsive: true, displayModeBar: false, displaylogo: false }}
      useResizeHandler
      style={{ width: "100%", height: "100%" }}
    />
  );
};

export default TailMatrixChart;